$(function(){
  var $select = $('#route_language_ids');

  if ($select.length > 0){
    default_language_ace_switch();
    $('#descriptions_content').on('cocoon:after-insert', function(event, insertedItem){
        var laguage = $(this).data('language_name'),
        description_id = $(this).data('language_id');

        console.log('cocoon:after-insert');

        $(insertedItem).attr({id: laguage +'_description'});
        $(insertedItem).find('.route_descriptions_language_id input, .unique_rfg_static_messages_language_id input').val(description_id);
        //$(insertedItem).find('.route_descriptions_message textarea').val(laguage);
        init_ace_switch();
        default_language_ace_switch();
    });

    var select_manager = new SelectManager($select);

    $select.change(function(){

      select_manager.change();

      var action  = select_manager.action,
          $option = select_manager.option,
          language = $option.data('language');

      switch(action) {
          case 'add':
            console.log('add');
            set_data_to_container($('#descriptions_content'), $option);

            $('#descriptions_content .add_fields').trigger('click');

            // aggiungo link tabs
            var $tab_link = tabs_link($option);
            $('#descriptions_tab').append($tab_link);
            $tab_link.find('a').trigger('click');
            break;
          case 'remove':
            console.log('remove');
            var description_id = language + '_description';
            // rimuovo link dalla tab e faccio click
            $('a[href*='+description_id+']').parents('li').remove();
            $('#descriptions_tab').find('li > a').first().trigger('click');
            // svuoto, nascondo e marchio per la rimozione il nested
            $('#'+description_id).find('textarea').html('').end().find('.remove_fields').trigger('click');
          break;
      }
    });
  }
});

function default_language_ace_switch(){
    $('#descriptions_content .lbl').on('click', function(){
        console.log('ciaooo');
        var id = $(this).parents('.nested-fields').find('.route_descriptions_language_id input').val();
        $checkbox = $(this).siblings('.ace-switch');
        checked = !$checkbox.is(":checked"); // al momento del click risulta lo stato iniziale
        console.log('checked ' + checked);
        if(checked){
            $('#route_default_language_id').val(id);
            // deseleziono gli altri
            var $checkboxes = $('.nested-fields').find('.lbl').not($(this));
            console.log('$checkboxes');
            $.each($checkboxes, function( index, checkbox ){
                $(checkbox).siblings('.ace-switch').removeClass("checked").removeAttr("checked").attr("value", 0);
            });
        } else {
            console.log('nessuno checkato');
            var $checkboxes = $('.nested-fields:visible').find('.lbl').not($(this)).siblings('.ace-switch:checked');
            if($checkboxes.length == 0 ){
                $('#route_default_language_id').val('');
            }
        }
    });
}

function set_data_to_container($container, $option){
    var option_id = $option.attr('value'),
        language = $option.data('language'),
        language_italian = $option.html();

    $container.data('language_id', option_id);
    $container.data('language_name', language);
    $container.data('language_italian_name', language_italian);
}

function tabs_link($option){
    var language = $option.data('language'),
        rawFlag = $option.data('flag'),
        language_italian = $option.html(),
        flagUrl = normalize_flag_url(rawFlag),
        flag = $('<img>').addClass('flag ' + language).attr({src: flagUrl}),
        link = $('<a>').data('toggle', 'tab').attr({'data-toggle': 'tab', href: '#' + language + '_description'}),
        li = $('<li>');
    li.append(link.append(flag).append(language_italian));

    return li;
}

function normalize_flag_url(value) {
    if (!value) { return ''; }
    var url = decodeURIComponent(value);
    if (/^https?:\/\//i.test(url) || url.indexOf('//') === 0) {
        return url;
    }
    if (url.charAt(0) !== '/') {
        return '/' + url.replace(/^\/+/, '');
    }
    return url;
}

function SelectManager($select) {
    this.select = $select;
    this.action = 'none';
    this.previous_option_ids = this.get_selected_option_ids();
    this.previous_options_size = this.previous_option_ids.length;
}

SelectManager.prototype.selected_options = function() {
    return this.select.find('option:selected');
};

SelectManager.prototype.get_selected_option_ids = function() {
    return $.map(this.selected_options(), function(option){ return $(option).val()});
};

SelectManager.prototype.change = function() {

    this.actual_option_ids = this.get_selected_option_ids();
    this.actual_option_ids_size = this.actual_option_ids.length;
    console.log('actual   -> ' + this.actual_option_ids);
    console.log('previous -> ' + this.previous_option_ids);

    this.set_action();
    this.option = this.selected_option();

    this.previous_option_ids = this.actual_option_ids
    this.previous_options_size = this.actual_option_ids_size
};

SelectManager.prototype.set_action = function() {
    this.action = (this.actual_option_ids_size > this.previous_options_size) ? 'add' : 'remove';
};

SelectManager.prototype.changed_id = function() {
    var diff_array = (this.action == 'add') ? _.difference(this.actual_option_ids, this.previous_option_ids) : _.difference(this.previous_option_ids, this.actual_option_ids);
    return _.first(diff_array);
};

SelectManager.prototype.selected_option = function() {
    var diff_array = (this.action == 'add') ? _.difference(this.actual_option_ids, this.previous_option_ids) : _.difference(this.previous_option_ids, this.actual_option_ids),
        id = _.first(diff_array);
    return this.select.find('option[value=' + id + ']');
};
